import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllMealsData } from "../../../redux/reducers/apiSlice";
import { selectToken } from "../../auth/auth.selector";
import {
  totalCalory,
  totalCarbs,
  totalFat,
  totalProtein,
} from "../common/CaloryCalculations";
import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import { generatePlanDuration } from "../../common-data/DropdowData";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";

const DPSubForm = ({
  dayNo,
  selectedDay,
  formValues,
  setFormValues,
  dpFormErrors,
  allFormValues,
  planDuration,
  selectedCopyFrom,
  setSelectedCopyFrom,
}) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { allMealsData } = useSelector((state) => state.api);


  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [mealCategories, setAllMealCategories] = useState([]);
  const [planDurations, setPlanDurations] = useState([]);

  const copyPreviousDay = () => {
    if (dayNo > 0) {
      const previousDayIndex = dayNo - 1;
      const previousDayValues = allFormValues[previousDayIndex];

      setFormValues((prevFormValues) => {
        return {
          ...prevFormValues,
          goalDiets: prevFormValues.goalDiets.map((day, index) => {
            if (index === dayNo) {
              return day.map((daykey, indkey) => {
                const matchedDay =
                  previousDayValues &&
                  previousDayValues.find(
                    (prevDay) =>
                      prevDay.mealTaglineValue === daykey.mealTaglineValue
                  );

                if (matchedDay) {
                  return {
                    ...daykey,
                    meals: [...matchedDay.meals],
                  };
                } else {
                  return daykey;
                }
              });
            } else {
              return day;
            }
          }),
        };
      });
    }
  };

  const copyLastWeek = () => {
    const startDayIndex = dayNo;
    const labelParts = selectedDay.label.split("-");
    const weekOffset = Number(labelParts[1]) - Number(labelParts[0]) + 1;

    if (startDayIndex >= weekOffset) {
      const previousWeekStart = startDayIndex - weekOffset;
      const previousWeekEnd = Number(labelParts[0]) - 1;
      // const previousWeekEnd = previousWeekStart + weekOffset -1; // End index of the previous week

      const copyDayValues = (sourceDayValues, currentFormValues) => {
        const currentDay = currentFormValues[0].dayNo;

        return sourceDayValues.map((daykey, indkey) => {
          const matchedDay =
            sourceDayValues &&
            sourceDayValues.find(
              (srcDay) => srcDay.mealTaglineValue === daykey.mealTaglineValue
            );

          if (matchedDay) {
            const { dayNo, ...otherValues } = matchedDay;

            return {
              ...daykey,
              ...otherValues,
              dayNo: currentDay,
              meals: [...matchedDay.meals],
            };
          } else {
            return daykey;
          }
        });
      };

      setFormValues((prevFormValues) => {
        const updatedFormValues = { ...prevFormValues };

        for (let i = previousWeekStart; i < previousWeekEnd; i++) {
          const targetDayIndex = i - previousWeekStart + startDayIndex;
          const previousDayValues = allFormValues[i];

          if (previousDayValues) {
            // const copied = copyDayValues(
            //   previousDayValues,
            //   updatedFormValues.goalDiets[targetDayIndex]
            // );

            updatedFormValues.goalDiets[targetDayIndex] = copyDayValues(
              previousDayValues,
              updatedFormValues.goalDiets[targetDayIndex]
            );
          }
        }

        return updatedFormValues;
      });
    }
  };

  const copySelectedDay = () => {
    const selectedDayIndex = selectedCopyFrom?.value
      ? selectedCopyFrom.value - 1
      : 0;
    const selectedDayValues = allFormValues[selectedDayIndex];

    // console.log("selectedDayValues=> ", selectedDayValues);

    if (selectedDayValues) {
      setFormValues((prevFormValues) => {
        return {
          ...prevFormValues,
          goalDiets: prevFormValues.goalDiets.map((day, index) => {
            if (dayNo === index) {
              return day.map((daykey, indkey) => {
                const matchedDay =
                  selectedDayValues &&
                  selectedDayValues.find(
                    (selDay) =>
                      selDay.mealTaglineValue === daykey.mealTaglineValue
                  );

                // console.log("=> ", {
                //   ...daykey,
                //   meals: [...matchedDay.meals],
                // });

                if (matchedDay) {
                  return {
                    ...daykey,
                    meals: [...matchedDay.meals],
                  };
                } else {
                  return daykey;
                }
              });
            } else {
              return day;
            }
          }),
        };
      });
    }
  };

  const handleAddMore = (dayIndex, categoryIndex, mealIndex, mealsArray) => {
    setFormValues((prevFormValues) => {
      const updatedFormValues = [...prevFormValues.goalDiets];

      if (Array.isArray(updatedFormValues)) {
        if (
          updatedFormValues[dayIndex] &&
          updatedFormValues[dayIndex][categoryIndex]
        ) {
          const newMeal = {
            selectedMeal: "",
            quantity: "",
            selectedUnit: "",
            totalCalory: {},
          };

          const updatedMealsArray = [...mealsArray];

          updatedMealsArray.splice(mealIndex + 1, 0, newMeal);

          updatedFormValues[dayIndex][categoryIndex].meals = updatedMealsArray;
        }
      }

      return { ...prevFormValues, goalDiets: updatedFormValues };
    });
  };

  const handleRemove = (dayIndex, categoryIndex, mealIndex, mealsArray) => {
    setFormValues((prevFormValues) => {
      const updatedFormValues = [...prevFormValues.goalDiets];

      if (
        updatedFormValues[dayIndex] &&
        updatedFormValues[dayIndex][categoryIndex]
      ) {
        const categoryMeals = [...mealsArray];

        categoryMeals.splice(mealIndex, 1);

        updatedFormValues[dayIndex][categoryIndex].meals = categoryMeals;
      }

      return { ...prevFormValues, goalDiets: updatedFormValues };
    });
  };

  const handleQuantityChange = (
    e,
    dayIndex,
    categoryIndex,
    mealIndex,
    mealInfo
  ) => {
    const { value } = e.target;

    const totalCal = totalCalory(value, mealInfo?.cal || 0);
    const protiens = totalProtein(value, mealInfo?.protien_grams || 0);
    const fats = totalFat(value, mealInfo?.fat_grams || 0);
    const carbs = totalCarbs(value, mealInfo?.carbs_grams || 0);

    setFormValues((prevDPForm) => {
      const updatedDPForm = { ...prevDPForm };

      updatedDPForm.goalDiets[dayIndex][categoryIndex].meals[mealIndex] = {
        ...updatedDPForm.goalDiets[dayIndex][categoryIndex].meals[mealIndex],
        quantity: value,
        totalCalory: value
          ? {
              totalCal,
              protiens,
              fats,
              carbs,
            }
          : {},
      };

      return updatedDPForm;
    });
  };

  const handleMealSelectChange = (
    selectedOption,
    dayIndex,
    categoryIndex,
    mealIndex
  ) => {
    setFormValues((prevDPForm) => {
      const updatedDPForm = { ...prevDPForm };

      const updatedGoalDiets = [...updatedDPForm.goalDiets];

      const dayData = updatedGoalDiets[dayIndex];

      dayData[categoryIndex].meals[mealIndex] = {
        ...dayData[categoryIndex].meals[mealIndex],
        selectedMeal: selectedOption,
        quantity: "",
        totalCalory: {},
      };

      // dayData[categoryIndex].meals[mealIndex].selectedMeal = selectedOption;

      updatedGoalDiets[dayIndex] = dayData;

      updatedDPForm.goalDiets = updatedGoalDiets;

      return updatedDPForm;
    });
  };

  const handleSearchChange = (inputValue) => {
    setSearch(inputValue);
    setPage(1);
  };

  function getMeal(pageNo = 1, searchQuery = "") {
    dispatch(
      fetchAllMealsData({
        pageNo: pageNo,
        limit: 20,
        queryParameters: `&status=active${
          searchQuery ? `&search=${searchQuery}` : ""
        }`,
        token: token,
      })
    );
  }

  const fetchMoreData = () => {
    if (page + 1 <= totalPages) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const fetchPreviousData = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  useEffect(() => {
    getMeal(page, search);
  }, [page, search]);

  useEffect(() => {
    if (allMealsData?.status && allMealsData?.data?.length > 0) {
      const { data } = allMealsData || {};

      const meals = data?.map((meal) => ({
        label: meal?.name,
        value: meal?.uid,
        info: meal,
      }));
      setAllMealCategories(meals);
      setTotalPages(allMealsData?.pagination?.[0]?.pages);
    } else {
      setAllMealCategories([]);
      setTotalPages(1);
    }
  }, [allMealsData]);

  useEffect(() => {
    if (planDuration) {
      const plans = generatePlanDuration(planDuration);
      setPlanDurations(plans);
    }
  }, [planDuration]);

  return (
    <div className="sub-form-container">
      <div className="headinNbutton">
        <h2 className="sub-heading">Add Diet Plan</h2>

        {dayNo !== 0 && (
          <div className="flex-end">
            <button
              type="button"
              className="btn copy-button"
              onClick={copyPreviousDay}
            >
              copy previous day
            </button>

            {dayNo >= 7 ? (
              <button
                type="button"
                className="btn copy-button"
                onClick={copyLastWeek}
              >
                copy last week
              </button>
            ) : null}

            <div className="btn-with-label">
              <div
                className={`commonWrapper copy-from-btn ${
                  selectedCopyFrom ? "with-value" : ""
                }`}
              >
                <SelectDropdownLabel
                  options={planDurations}
                  selectedOption={selectedCopyFrom}
                  setSelectedOption={(selectedValue) =>
                    setSelectedCopyFrom(selectedValue)
                  }
                  name="Copy From"
                />
              </div>

              {selectedCopyFrom ? (
                <button
                  type="button"
                  className="btn copy-button"
                  onClick={copySelectedDay}
                >
                  Copy Selected Day
                </button>
              ) : null}
            </div>
          </div>
        )}
      </div>

      {Array.isArray(formValues) && formValues?.length > 0
        ? formValues.map((dayForm, dayIndex) => (
            <div className="sub-section" key={dayIndex}>
              <span className={`tagline `}>
                {dayForm.mealTagline?.replace(/_/g, " ")}
                {dayForm.mealTagline?.toLowerCase() === "breakfast" ||
                dayForm.mealTagline?.toLowerCase() === "lunch" ||
                dayForm.mealTagline?.toLowerCase() === "snacks" ||
                dayForm.mealTagline?.toLowerCase() === "dinner" ? (
                  <span className="impMark">*</span>
                ) : null}
              </span>

              <div className="selected-multi-box">
                {dayForm.meals
                  ? dayForm.meals.map((meal, mealIndex) => {
                      return (
                        <div className="flex-box" key={mealIndex}>
                          <div className="formInputBox longOne">
                            <label
                              htmlFor={`selectedMeal`}
                              className="formInputLabel"
                            >
                              choose meal *
                            </label>

                            <div
                              className={`commonWrapper ${
                                dpFormErrors?.selectedMeal ? "formError" : ""
                              } ${
                                dpFormErrors &&
                                dpFormErrors[
                                  `day${dayNo}_meal${dayIndex}_selectedMeal${mealIndex}`
                                ]
                                  ? "formError"
                                  : ""
                              }`}
                            >
                              <SelectDropdownDynamic
                                options={mealCategories}
                                name={`meal`}
                                selectedOption={meal.selectedMeal || ""}
                                setSelectedOption={(selectedOption) =>
                                  handleMealSelectChange(
                                    selectedOption,
                                    dayNo,
                                    dayIndex,
                                    mealIndex
                                  )
                                }
                                onSearchChange={handleSearchChange}
                                fetchMoreData={fetchMoreData}
                                fetchPreviousData={fetchPreviousData}
                              />
                            </div>

                            <div className="sub-input-values">
                              <div className="flex-box">
                                <div className="formInputBox longOne">
                                  <div className="sub-input-values">
                                    <span className="values">
                                      total cal-
                                      {meal.totalCalory?.totalCal
                                        ? parseFloat(
                                            meal.totalCalory.totalCal || 0
                                          ).toFixed(2)
                                        : 0}
                                    </span>
                                    <span className="values">
                                      protein-
                                      {meal.totalCalory?.protiens
                                        ? parseFloat(
                                            meal.totalCalory.protiens || 0
                                          ).toFixed(2)
                                        : 0}{" "}
                                      g
                                    </span>
                                    <span className="values">
                                      fat-
                                      {meal.totalCalory?.fats
                                        ? parseFloat(
                                            meal.totalCalory.fats || 0
                                          ).toFixed(2)
                                        : 0}{" "}
                                      g
                                    </span>
                                    <span className="values">
                                      carbs-
                                      {meal.totalCalory?.carbs
                                        ? parseFloat(
                                            meal.totalCalory.carbs || 0
                                          ).toFixed(2)
                                        : 0}{" "}
                                      g
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {dayForm.meals.length > 1 &&
                                mealIndex !== dayForm.meals.length - 1 && (
                                  <button
                                    type="button"
                                    className="remove-btn"
                                    onClick={() =>
                                      handleRemove(
                                        dayNo,
                                        dayIndex,
                                        mealIndex,
                                        dayForm.meals
                                      )
                                    }
                                  >
                                    X Remove
                                  </button>
                                )}

                              {(dayForm.meals.length === 1 ||
                                mealIndex === dayForm.meals.length - 1) && (
                                <button
                                  type="button"
                                  className="add-more-btn"
                                  onClick={() =>
                                    handleAddMore(
                                      dayNo,
                                      dayIndex,
                                      mealIndex,
                                      dayForm.meals
                                    )
                                  }
                                >
                                  + Add more
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="formInputBox shortOne">
                            <label
                              htmlFor={`quantity`}
                              className="formInputLabel"
                            >
                              enter quantity *
                            </label>
                            <div className="commonWrapper inputs">
                              <input
                                type="number"
                                placeholder="Quantity"
                                className={`formInput ${
                                  dpFormErrors?.quantity ? "formError" : ""
                                } ${
                                  dpFormErrors &&
                                  dpFormErrors[
                                    `day${dayNo}_meal${dayIndex}_quantity${mealIndex}`
                                  ]
                                    ? "formError"
                                    : ""
                                }`}
                                name={`quantity`}
                                value={meal.quantity || ""}
                                disabled={meal.selectedMeal ? false : true}
                                onChange={(e) =>
                                  handleQuantityChange(
                                    e,
                                    dayNo,
                                    dayIndex,
                                    mealIndex,
                                    meal.selectedMeal?.info
                                  )
                                }
                                min={0}
                              />

                              <div className="grayInputLine"></div>

                              <span className="value">
                                {meal.selectedMeal?.info?.unit_name || "NA"}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default DPSubForm;
